export default "__VITE_ASSET__d3f2f623__"